import {
    Injectable,
    Injector,
    EmbeddedViewRef,
    ApplicationRef,
    createComponent
} from '@angular/core';
import { IModalConfig } from './modal-config';

@Injectable({
    providedIn: 'root'
})
export class DomService
{
    private childComponentRef: any;

    constructor(
        private appRef: ApplicationRef,
        private injector: Injector
    ) { }

    public appendComponentTo (parentId: string, child: any, childConfig?: IModalConfig)
    {
        // Create a component reference from the component
        // ComponentFactoryResolver a ete supprime en Angular 22 : remplacement par createComponent.
        const childComponentRef = createComponent(child, {
            environmentInjector: this.appRef.injector,
            elementInjector: this.injector
        });

        // Attach the config to the child (inputs and outputs)
        this.attachConfig(childConfig, childComponentRef);

        this.childComponentRef = childComponentRef;
        // Attach component to the appRef so that it's inside the ng component tree
        this.appRef.attachView(childComponentRef.hostView);

        // Get DOM element from component
        const childDomElem = (childComponentRef.hostView as EmbeddedViewRef<any>)
            .rootNodes[0] as HTMLElement;

        // Append DOM element to the body
        document.getElementById(parentId).appendChild(childDomElem);

    }

    public removeComponent ()
    {
        this.appRef.detachView(this.childComponentRef.hostView);
        this.childComponentRef.destroy();
    }


    private attachConfig (config: IModalConfig, componentRef)
    {
        const inputs = config.inputs;
        for (const key in inputs)
        {
            componentRef.instance[key] = inputs[key];
        }
    }
}
